import * as React from 'react';

export default ({ countWaitForPublish, onPublish, publishing, onReset }: {
  publishing: boolean;
  countWaitForPublish: number;
  onPublish: IFunction;
  onReset: IFunction;
}) => {
  return (
    <div>
      <span style={{ marginRight: 10 }}>待发布数量：{countWaitForPublish}</span>
      <button
        style={{ marginRight: 3 }}
        disabled={publishing}
        onClick={onPublish}
      >
        {publishing ? '正在发布' : '发布'}
      </button>
      <button disabled={publishing} onClick={onReset}>重置</button>
      <br/>
    </div>
  );
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/views/PublisherView.tsx